module.exports = __webpack_public_path__ + "static/media/vehicle-lights.08639f0a.mp4";